import styled from "styled-components";
import {TooltipContainerDefaultBox} from "./tooltip-container.default";


export const TooltipContainer777Box = styled(TooltipContainerDefaultBox)`
    z-index: 203; //The 777 drawer is 202, so we are 203
    border-color:  ${({borderColor}) => borderColor ? borderColor : 'black'};  
`;